<script>
  import Header from "../Component/Header.svelte";
  import { Button } from "../../Components";
  import { Loading, CFA } from "../../Components/Icons";
  import CFAText from "../Component/CFAText.svelte";
  import Workshop from "./Wsggo2o/Workshop.svelte";
  import Gruppengespraech from "./Wsggo2o/Gruppengespraech.svelte";
  import Onetoone from "./Wsggo2o/Onetoone.svelte";
  import Pagination from "./Wsggo2o/Pagination.svelte";
  import { doLoading, doBaseListLoading, doBaseDataLoading, doDialogLoading, doDialogListLoading } from "../Api/congress_stores.js";
  import Select from "svelte-select";
  import { Wsggo2o, Wsggo2obaselist, Wsggo2obasedata } from "../Api/congress";
  import { operationStore, query } from "@urql/svelte";
  import Dialog from "../Component/Dialog.svelte";

  let dialog;

  let showLoading = true;
  let showBaseListLoading = true;
  let showBaseDataLoading = true;
  let showDialogLoading = true;
  let showDialogListLoading = true;
  const requestPolicy = "network-only";

  let filterChanged = false;

  doLoading.subscribe((value) => {
    showLoading = value;
  });
  doBaseListLoading.subscribe((value) => {
    showBaseListLoading = value;
  });
  doBaseDataLoading.subscribe((value) => {
    showBaseDataLoading = value;
  });
  doDialogLoading.subscribe((value) => {
    showDialogLoading = value;
  });
  doDialogListLoading.subscribe((value) => {
    showDialogListLoading = value;
  });

  const itemComponents = {
    1: Workshop,
    2: Gruppengespraech,
    3: Onetoone,
  };

  export let congressId;
  const widgetView = "wsggo2o";

  let data = {};
  let baselist = {};
  let basedata = {};
  let eventlistKeyed = [];
  let dialogevent = {};
  let dialogeventKeyed = {};
  let basedialoglist = {};

  let showKennzeichnung = false;
  let shownWsDetailtext = false;
  let shownGgDetailtext = false;
  let shownO2oDetailtext = false;
  let shownCFADetailtext = false;

  const itemIdSponsor = "ausstellerId";
  const itemIdCategory = "categoryId";

  let filterCategoryId = undefined;
  let filterAusstellerId = undefined;
  let showAusstellerId = undefined;
  let showAusstellerIdData = undefined;
  let showCategoryId = undefined;
  let showCategoryIdData = undefined;
  let filterWs = 1;
  let filterGg = 1;
  let filterO2o = 1;
  let filterDay1 = 1;
  let filterDay2 = 1;

  let filterWsCB = true;
  let filterGgCB = true;
  let filterO2oCB = true;

  let filterDay1CB = true;
  let filterDay2CB = true;

  let filterCfa = 0;
  let filterCfaCB = false;

  let showVeranstaltungId = 0;

  let action = "";
  let actionVeranstaltungId = 0;
  let actionBlocknumber = 0;

  let itemListLength = 0;

  let itemsPerPage = 10;
  let displayPage = 1;
  let maxPage = 1;
  let startItemNumber = 1;
  let endItemNumber = 1;
  let startPageNumber = 1;
  let endPageNumber = 1;

  const url = new URL(window.location);
  let myVid = Number.parseInt(url.searchParams.get("vid"));
  let myGid = Number.parseInt(url.searchParams.get("gid"));
  let myGt = Number.parseInt(url.searchParams.get("gt"));

  if (myGid > 0) {
    filterAusstellerId = myGid;
    showAusstellerId = myGid;
  }
  if (myVid > 0) {
    showVeranstaltungId = myVid;
  }
  if (myGt > 0) {
    switch (myGt) {
      case 1:
        filterWsCB = true;
        filterGgCB = false;
        filterO2oCB = false;
        filterWs = 1;
        filterGg = 0;
        filterO2o = 0;
        break;
      case 2:
        filterWsCB = false;
        filterGgCB = true;
        filterO2oCB = false;
        filterWs = 0;
        filterGg = 1;
        filterO2o = 0;
        break;
      case 3:
        filterWsCB = false;
        filterGgCB = false;
        filterO2oCB = true;
        filterWs = 0;
        filterGg = 0;
        filterO2o = 1;
        break;
      case 4:
        filterWsCB = true;
        filterGgCB = true;
        filterO2oCB = false;
        filterWs = 1;
        filterGg = 1;
        filterO2o = 0;
        break;
    }
  }
  if (myGt == -1) {
    filterWsCB = true;
    filterGgCB = true;
    filterO2oCB = true;
    filterWs = 1;
    filterGg = 1;
    filterO2o = 1;
  }

  function showNextItemsPage() {
    if (displayPage < maxPage) {
      displayPage++;
      calcPageValues();
    }
  }

  function showPreviousItemsPage() {
    if (displayPage > 1) {
      displayPage--;
      calcPageValues();
    }
  }

  function showPageDirect(showPageNumber) {
    displayPage = showPageNumber;
    calcPageValues();
  }

  function calcPageValues() {
    itemListLength = baselist?.eventlist?.length || 0;

    maxPage = Math.ceil(itemListLength / parseInt(itemsPerPage));

    startPageNumber = displayPage - 4;
    if (startPageNumber < 1) {
      startPageNumber = 1;
    }

    endPageNumber = displayPage + 4;
    if (displayPage - startPageNumber < 5) {
      endPageNumber += 4 - (displayPage - startPageNumber);
    }
    if (endPageNumber > maxPage) {
      endPageNumber = maxPage;
    }
    if (endPageNumber - displayPage < 4) {
      startPageNumber -= 4 - (endPageNumber - displayPage);
    }
    if (startPageNumber < 1) {
      startPageNumber = 1;
    }

    startItemNumber = (displayPage - 1) * parseInt(itemsPerPage) + 1;
    endItemNumber = startItemNumber + (parseInt(itemsPerPage) - 1);

    if (endItemNumber > itemListLength) {
      endItemNumber = itemListLength;
    }
  }

  const wsggo2o = operationStore(
    Wsggo2o,
    {
      congressId,
      widgetView,
      filterCategoryId,
      filterAusstellerId,
      filterWs,
      filterGg,
      filterO2o,
      filterDay1,
      filterDay2,
      filterCfa,
      action,
      actionVeranstaltungId,
      actionBlocknumber,
      showVeranstaltungId,
    },
    {
      requestPolicy,
    },
  );

  const wsggo2odialog = operationStore(
    Wsggo2o,
    {
      congressId,
      widgetView,
      filterCategoryId,
      filterAusstellerId,
      filterWs,
      filterGg,
      filterO2o,
      filterDay1,
      filterDay2,
      filterCfa,
      action,
      actionVeranstaltungId,
      actionBlocknumber,
      showVeranstaltungId,
    },
    {
      requestPolicy,
    },
  );

  const wsggo2obaselist = operationStore(
    Wsggo2obaselist,
    {
      congressId,
      widgetView,
      filterCategoryId,
      filterAusstellerId,
      filterWs,
      filterGg,
      filterO2o,
      filterDay1,
      filterDay2,
      filterCfa,
      showVeranstaltungId,
    },
    {
      requestPolicy,
    },
  );

  const wsggo2odialoglist = operationStore(
    Wsggo2obaselist,
    {
      congressId,
      widgetView,
      filterCategoryId,
      filterAusstellerId,
      filterWs,
      filterGg,
      filterO2o,
      filterDay1,
      filterDay2,
      filterCfa,
      showVeranstaltungId,
    },
    {
      requestPolicy,
    },
  );

  const wsggo2obasedata = operationStore(
    Wsggo2obasedata,
    {
      congressId,
      widgetView,
    },
    {
      requestPolicy,
    },
  );

  function processBookingAction(event) {
    const { actionType, actionId, actionBlocknumber } = event.detail;

    action = actionType;
    actionVeranstaltungId = actionId;

    wsggo2o.variables.action = actionType;
    wsggo2o.variables.actionVeranstaltungId = actionId;
    wsggo2o.variables.actionBlocknumber = actionBlocknumber;
    wsggo2o.reexecute();
  }

  function reloadList() {
    wsggo2obaselist.variables.action = "";
    wsggo2obaselist.variables.actionVeranstaltungId = 0;
    wsggo2obaselist.variables.showVeranstaltungId = 0;
    myGid = 0;
    myVid = 0;
    myGt = 0;

    doBaseListLoading.update(() => true);
    doLoading.update(() => true);

    wsggo2obaselist.variables.filterWs = filterWsCB ? 1 : 0;
    wsggo2obaselist.variables.filterGg = filterGgCB ? 1 : 0;
    wsggo2obaselist.variables.filterO2o = filterO2oCB ? 1 : 0;

    if (!filterDay1CB && !filterDay2CB) {
      filterDay1CB = true;
      filterDay2CB = true;
    }

    wsggo2obaselist.variables.filterDay1 = filterDay1CB ? 1 : 0;
    wsggo2obaselist.variables.filterDay2 = filterDay2CB ? 1 : 0;
    wsggo2obaselist.variables.filterCfa = filterCfaCB ? 1 : 0;
    wsggo2obaselist.reexecute();

    wsggo2o.variables.action = "";
    wsggo2o.variables.actionVeranstaltungId = 0;
    wsggo2o.variables.showVeranstaltungId = 0;

    wsggo2o.variables.filterWs = filterWsCB ? 1 : 0;
    wsggo2o.variables.filterGg = filterGgCB ? 1 : 0;
    wsggo2o.variables.filterO2o = filterO2oCB ? 1 : 0;

    wsggo2o.variables.filterDay1 = filterDay1CB ? 1 : 0;
    wsggo2o.variables.filterDay2 = filterDay2CB ? 1 : 0;
    wsggo2o.variables.filterCfa = filterCfaCB ? 1 : 0;
    wsggo2o.reexecute();
  }

  function showVeranstaltung(event) {
    showVeranstaltungId = event.detail.showVeranstaltungId;

    wsggo2odialoglist.variables.action = "";
    wsggo2odialoglist.variables.actionVeranstaltungId = 0;
    wsggo2odialoglist.variables.showVeranstaltungId = showVeranstaltungId;
    wsggo2odialoglist.reexecute();

    wsggo2odialog.variables.action = "";
    wsggo2odialog.variables.actionVeranstaltungId = 0;
    wsggo2odialog.variables.showVeranstaltungId = showVeranstaltungId;
    wsggo2odialog.reexecute();

    dialog.showModal();

    //    wsggo2o.variables.action = "";
    //    wsggo2o.variables.actionVeranstaltungId = 0;
    //    wsggo2o.variables.showVeranstaltungId = showVeranstaltungId;
    //    wsggo2o.reexecute();
  }

  query(wsggo2obasedata);
  query(wsggo2obaselist);
  query(wsggo2o);
  query(wsggo2odialog);
  query(wsggo2odialoglist);

  wsggo2o.subscribe((storeObj) => {
    showLoading = storeObj.fetching;
    if (!showLoading && storeObj.data) {
      data = storeObj.data.wsggo2odata;
      data.anmeldestop = data.anmeldestop == 1;
      data.anmeldestopO2o = data.anmeldestopO2o == 1;

      eventlistKeyed = [];
      data.eventlist.forEach(function (myEvent) {
        eventlistKeyed[myEvent.veranstaltungId] = myEvent;
      });

      doLoading.update(() => false);

      action = "";
      actionVeranstaltungId = 0;

      wsggo2o.variables.action = action;
      wsggo2o.variables.actionVeranstaltungId = actionVeranstaltungId;
    }
  });

  wsggo2odialog.subscribe((storeObj) => {
    showDialogLoading = storeObj.fetching;
    if (!showDialogLoading && storeObj.data) {
      dialogevent = storeObj.data.wsggo2odata;
      dialogevent.anmeldestop = dialogevent.anmeldestop == 1;
      dialogevent.anmeldestopO2o = dialogevent.anmeldestopO2o == 1;

      dialogevent.eventlist.forEach(function (myEvent) {
        dialogeventKeyed[myEvent.veranstaltungId] = myEvent;
      });

      doDialogLoading.update(() => false);

      action = "";
      actionVeranstaltungId = 0;

      wsggo2odialog.variables.action = action;
      wsggo2odialog.variables.actionVeranstaltungId = actionVeranstaltungId;
    }
  });

  wsggo2obaselist.subscribe((storeObj) => {
    showBaseListLoading = storeObj.fetching;
    if (!showBaseListLoading && storeObj.data) {
      baselist = storeObj.data.wsggo2obaselistdata;

      doBaseListLoading.update(() => false);

      displayPage = 1;

      itemsPerPage = baselist?.eventlist?.length || 50;

      calcPageValues();
    }
  });
  wsggo2odialoglist.subscribe((storeObj) => {
    showDialogListLoading = storeObj.fetching;
    if (!showDialogListLoading && storeObj.data) {
      basedialoglist = storeObj.data.wsggo2obaselistdata;

      doDialogListLoading.update(() => false);
    }
  });
  wsggo2obasedata.subscribe((storeObj) => {
    showBaseDataLoading = storeObj.fetching;
    if (!showBaseDataLoading && storeObj.data) {
      basedata = storeObj.data.wsggo2obasedata;
      basedata.anmeldestop = basedata.anmeldestop == 1;
      basedata.anmeldestopO2o = basedata.anmeldestopO2o == 1;

      doBaseDataLoading.update(() => false);

      if (myGid > 0) {
        showAusstellerId = myGid;

        basedata.sponsorListShort.forEach(function (mySponsor) {
          if (mySponsor.ausstellerId == showAusstellerId) {
            showAusstellerIdData = mySponsor;
          }
        });
      }
    }
  });

  function handleSelectCategory(selectedVal) {
    filterCategoryId = selectedVal.detail.categoryId;
    $wsggo2obaselist.variables.filterCategoryId = filterCategoryId;
    $wsggo2o.variables.filterCategoryId = filterCategoryId;

    showCategoryId = filterCategoryId;

    basedata.categoryList.forEach(function (myCategory) {
      if (myCategory.categoryId == showCategoryId) {
        showCategoryIdData = myCategory;
      }
    });

    filterChanged = true;
  }

  function handleCategoryClear() {
    filterCategoryId = undefined;
    $wsggo2obaselist.variables.filterCategoryId = filterCategoryId;
    $wsggo2o.variables.filterCategoryId = filterCategoryId;

    showCategoryId = undefined;
    showCategoryIdData = undefined;
  }

  function handleSelectSponsor(selectedVal) {
    currentWindowLocation = "" + window.location;
    if (currentWindowLocation.indexOf("?") > -1) {
      window.history.pushState(null, "", currentWindowLocation.substr(0, currentWindowLocation.indexOf("?")));
    }
    myVid = 0;
    myGid = 0;
    myGt = 0;

    filterAusstellerId = selectedVal.detail.ausstellerId;
    $wsggo2obaselist.variables.filterAusstellerId = filterAusstellerId;
    $wsggo2o.variables.filterAusstellerId = filterAusstellerId;

    showAusstellerId = filterAusstellerId;

    basedata.sponsorListShort.forEach(function (mySponsor) {
      if (mySponsor.ausstellerId == showAusstellerId) {
        showAusstellerIdData = mySponsor;
      }
    });

    filterChanged = true;
  }

  function handleSponsorClear() {
    filterAusstellerId = undefined;
    $wsggo2obaselist.variables.filterAusstellerId = filterAusstellerId;
    $wsggo2o.variables.filterAusstellerId = filterAusstellerId;

    currentWindowLocation = "" + window.location;
    if (currentWindowLocation.indexOf("?") > -1) {
      window.history.pushState(null, "", currentWindowLocation.substr(0, currentWindowLocation.indexOf("?")));
    }

    myVid = 0;
    myGid = 0;
    myGt = 0;

    showAusstellerId = undefined;
    showAusstellerIdData = undefined;
  }

  function resetSettings() {
    filterWsCB = true;
    filterGgCB = true;
    filterO2oCB = true;

    filterDay1CB = true;
    filterDay2CB = true;

    filterCfaCB = false;

    currentWindowLocation = "" + window.location;
    if (currentWindowLocation.indexOf("?") > -1) {
      window.history.pushState(null, "", currentWindowLocation.substr(0, currentWindowLocation.indexOf("?")));
    }
    myVid = 0;
    myGid = 0;
    myGt = 0;

    filterAusstellerId = 0;
    $wsggo2obaselist.variables.filterAusstellerId = filterAusstellerId;
    $wsggo2o.variables.filterAusstellerId = filterAusstellerId;

    filterCategoryId = 0;
    $wsggo2obaselist.variables.filterCategoryId = filterCategoryId;
    $wsggo2o.variables.filterCategoryId = filterCategoryId;

    myGid = 0;
    myVid = 0;
    showAusstellerId = undefined;
    showAusstellerIdData = undefined;
    showCategoryId = undefined;
    showCategoryIdData = undefined;

    filterChanged = false;

    reloadList();
  }

  function setFilterChanged() {
    filterChanged = true;
  }
</script>

<Header {congressId} {...basedata} />

<div class="prose max-w-none prose-h2:mb-0 prose-h2:text-xl">
  <strong>Ihre persönliche Programmübersicht finden Sie hier:</strong>
  <a href="/kongress/mein-account#myEvents|overview" class="text-theme-signal"
    ><svg class="svg-inline--fa fa-xl" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
      ><path
        d="M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"
      ></path></svg
    ></a
  >

  <h2>Workshops</h2>
  <p>
    Ein zentraler Programmpunkt des Institutional Money Kongresses {basedata?.congressYear || ""}
    werden die Workshops von {basedata?.anzahlWorkshops || ""} renommierten Investmentgesellschaften sein.
    {#if !shownWsDetailtext}
      <Button
        link
        on:click={() => {
          shownWsDetailtext = true;
        }}
      >
        Mehr erfahren &raquo;
      </Button>
    {/if}
  </p>
  {#if shownWsDetailtext}
    <p>
      Es werden immer rund dreizehn 45-minütige Workshops parallel geführt. Da es eine begrenzte Sitzplatzanzahl - je 30 Plätze - pro Workshop gibt, bieten wir unseren Fachbesuchern die Möglichkeit
      online einen Sitzplatz für den Workshop Ihrer Wahl zu sichern. Ihr reservierter Sitzplatz befindet sich in den vorderen Reihen.
    </p>
    <p>
      Bitte beachten Sie, dass nur zwei Drittel der Sitzplätze vorab online reserviert werden können. Falls das Platzkontingent bereits erschöpft ist, ersuchen wir Sie, die Möglichkeit der Warteliste
      zu nutzen, damit wir Ihren Wünschen so gut wie möglich nachkommen können. Für in Englisch gehaltene Workshops bieten wir Simultanübersetzung an.
    </p>
  {/if}

  <h2>Gruppengespräche</h2>
  <p>
    Ein institutioneller Investor bzw. ein Consultingunternehmen befragt im kleinen Rahmen einen Fondsmanager.
    {#if !shownGgDetailtext}
      <Button
        link
        on:click={() => {
          shownGgDetailtext = true;
        }}
      >
        Mehr erfahren &raquo;
      </Button>
    {/if}
  </p>
  {#if shownGgDetailtext}
    <p>
      Hierfür werden eigens Besprechungsräume im Kongresscenter zur Verfügung gestellt. Die Diskussion ist für maximal vier weitere Personen ausschließlich gegen Voranmeldung geöffnet. Falls ein
      Gruppengespräch bereits ausgebucht ist, haben Sie die Möglichkeit sich auf die Warteliste setzen zu lassen. Sollte ein Sitzplatz frei werden, werden wir Sie über ein mögliches Nachrücken gerne
      informieren.
    </p>
  {/if}
  <h2>One to One</h2>
  <p>
    Ein exklusives Informationsangebot sind auch {data?.congressYear || ""} die One to One Gespräche mit ausgewählten Fondsmanagern.
    {#if !shownO2oDetailtext}
      <Button
        link
        on:click={() => {
          shownO2oDetailtext = true;
        }}
      >
        Mehr erfahren &raquo;
      </Button>
    {/if}
  </p>
  {#if shownO2oDetailtext}
    <p>
      Wer sich wirklich konzentriert mit einem einzelnen Asset Manager unterhalten will, kann dies in einem vorab organisierten Einzelgespräch ungestört tun. Dafür gibt es eine eigens geschaffene
      Besprechungs-Lounge.
      {#if !basedata?.anmeldestopO2o && basedata.o2oAnmeldezeitpunkt != ""}
        Die Anmeldung zu Ihrem persönlichen Vier-Augen-Gespräch ist ab {basedata.o2oAnmeldezeitpunkt} möglich!{/if}
    </p>
  {/if}

  {#if congressId < 179}
    <CFAText intro="Weiterbildung für CFA-Mitglieder am Institutional Money Kongress mit CFA Continued Education Points" description={null} />
    {#if showKennzeichnung}
      <p>Die Kennzeichnung der einzelnen Workshops erfolgt im März.</p>
    {/if}
  {:else}
    <div class="flex max-w-none items-center gap-2 font-bold">
      <figure class="m-0">
        <CFA class="w-60" />
      </figure>
      <p class="m-0">
        Weiterbildung für CFA-Mitglieder am Institutional Money Kongress mit CFA Professional Learning Credits
        {#if !shownCFADetailtext}
          <Button
            link
            on:click={() => {
              shownCFADetailtext = true;
            }}
          >
            Mehr erfahren &raquo;
          </Button>
        {/if}
      </p>
    </div>
    {#if shownCFADetailtext}
      <p>
        Die CFA Society Germany und die CFA Society Austria haben festgelegt, dass das Angebot aus Experten Vorträgen und Workshops des Institutional Money Kongresses den Guidelines des CFA
        Institute Professional Learning Programs entsprechen. CFA Institute Members erhalten 3 PL Credits pro Tag, sofern sie den ganzen Tag anwesend sind. Lassen Sie sich daher bitte in der Lounge
        der CFA Society regis­trieren. So kann Ihre Anwesenheit erfasst werden, und es wird Ihnen die entsprechende Anzahl von Credits vorgemerkt. Registrierte CFA Institute Members werden PL Credit
        Hours für ihre Teilnahme auto­matisch im PL Tracking Tool gutgeschrieben.
      </p>
    {/if}
  {/if}
</div>

{#if !showBaseDataLoading}
  <div class="my-5 bg-theme-gray-200 p-2.5">
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <div>
        <label for={itemIdCategory} class="font-bold">Kategorie:</label>
        <Select
          itemId="categoryId"
          label="categoryName"
          items={basedata.categoryList}
          id={itemIdCategory}
          on:change={handleSelectCategory}
          placeholder="Alle"
          on:clear={handleCategoryClear}
          bind:value={showCategoryIdData}
        />
      </div>
      <div>
        <label for={itemIdSponsor} class="font-bold">Gesellschaft:</label>
        <Select
          itemId="ausstellerId"
          label="companynameIMK"
          items={basedata.sponsorListShort}
          id={itemIdSponsor}
          on:change={handleSelectSponsor}
          placeholder="Alle"
          on:clear={handleSponsorClear}
          bind:value={showAusstellerIdData}
        />
      </div>
    </div>
    <fieldset class="mt-4">
      <legend class="font-bold">Veranstaltungstyp:</legend>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <label class="flex cursor-pointer items-center gap-x-2">
          <input class="form-checkbox" name="workshops" type="checkbox" value="J" bind:checked={filterWsCB} on:click={setFilterChanged} /> Workshops
        </label>
        <label class="flex cursor-pointer items-center gap-x-2">
          <input class="form-checkbox" name="gruppengespraeche" type="checkbox" value="J" bind:checked={filterGgCB} on:click={setFilterChanged} /> Gruppengespräche
        </label>
        <label class="flex cursor-pointer items-center gap-x-2">
          <input class="form-checkbox" name="onetoone" type="checkbox" value="J" bind:checked={filterO2oCB} on:click={setFilterChanged} /> One to one
        </label>
      </div>
    </fieldset>
    <fieldset class="mt-4">
      <legend class="font-bold">Veranstaltungstag:</legend>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <label class="flex cursor-pointer items-center gap-x-2">
          <input class="form-checkbox" name="tag1" type="checkbox" value="J" bind:checked={filterDay1CB} on:click={setFilterChanged} /> 1. Tag
        </label>
        <label class="flex cursor-pointer items-center gap-x-2">
          <input class="form-checkbox" name="tag2" type="checkbox" value="J" bind:checked={filterDay2CB} on:click={setFilterChanged} /> 2. Tag
        </label>
      </div>
    </fieldset>

    <div class="mt-4 flex flex-wrap items-center gap-2">
      <Button main on:click={reloadList} disabled={showBaseListLoading}>Filtern</Button>
      <Button ghost on:click={resetSettings} disabled={!filterChanged}>Zurücksetzen</Button>
      <Loading showLoading={showBaseListLoading} />
    </div>
    <input type="hidden" name="displaypage" value="1" />
  </div>

  {#if !showBaseListLoading}
    {#if baselist.eventlist.length}
      <Pagination
        showCounter
        {startItemNumber}
        {endItemNumber}
        {itemListLength}
        {startPageNumber}
        {endPageNumber}
        {displayPage}
        {showPageDirect}
        {showNextItemsPage}
        {showPreviousItemsPage}
        bind:itemsPerPage
        {calcPageValues}
      />
      <div class="my-6" id="veranstaltungsliste">
        {#each baselist.eventlist as item, itemKey}
          {#if itemKey + 1 >= startItemNumber && itemKey + 1 <= endItemNumber}
            {#if !showLoading}
              <svelte:component
                this={itemComponents[item.typ]}
                {item}
                anmeldestop={data?.anmeldestop}
                anmeldestopO2o={data?.anmeldestopO2o}
                on:booking={processBookingAction}
                on:showVeranstaltung={showVeranstaltung}
                eventlistData={eventlistKeyed[item.veranstaltungId]}
              />
            {:else}
              <Loading display="block" class="mx-auto my-8" />
            {/if}
          {/if}
        {/each}
      </div>
      <Pagination {startPageNumber} {endPageNumber} {displayPage} {showPageDirect} {showNextItemsPage} {showPreviousItemsPage} />
    {:else}
      <p class="mt-4">
        Leider wurde keine zu ihrer Auswahl passende Veranstaltung gefunden. Bitte ändern Sie ihre Auswahl oder lassen Sie
        <Button link on:click={resetSettings}>alle Veranstaltungen anzeigen</Button>.
      </p>
    {/if}
  {:else}
    <Loading display="block" class="mx-auto my-8" />
  {/if}
{:else}
  <Loading display="block" class="mx-auto my-8" />
{/if}

<Dialog bind:dialog>
  {#if !showDialogListLoading}
    <div class="mr-2.5 flex justify-end">
      <button class="text-3xl" on:click={() => dialog.close()}>x</button>
    </div>
    {#each basedialoglist.eventlist as item, itemKey}
      <svelte:component
        this={itemComponents[item.typ]}
        {item}
        anmeldestop={basedialoglist?.anmeldestop}
        anmeldestopO2o={basedialoglist?.anmeldestopO2o}
        on:booking={processBookingAction}
        on:showVeranstaltung={showVeranstaltung}
        eventlistData={dialogeventKeyed[item.veranstaltungId]}
      />
    {/each}
  {:else}
    <Loading display="block" class="mx-auto my-8" />
  {/if}
</Dialog>
